import AppNavbar from "@/components/common/AppNavbar";
import Breadcrumbs from "@/components/common/Breadcrumbs";

import CourierRegistrationForm from "../components/forms/CourierRegistrationForm";

export default function BecomeCourierPage() {
  return (
    <>
      <AppNavbar />
      <div className="bg-base-200 pt-16">
        <Breadcrumbs />
        <div className="flex min-h-screen w-full items-stretch justify-stretch px-4 py-6 sm:px-6 lg:px-8">
          <CourierRegistrationForm />
        </div>
      </div>
    </>
  );
}
